import { Reducer } from 'redux';
import { Action, ActionType } from '../../actions';
import { EditorData } from '../../state/MarkupsV2/EditorData';
import { ValidationUtils } from '../../../utils/ValidationUtils';

const updateMarkupsV2EditorData: Reducer<EditorData> = (state: EditorData = new EditorData(), action: Action<ActionType, EditorData>) => {
  switch (action.type) {
    case ActionType.MARKUP_V2_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.MARKUP_V2_EDITOR_DATA_UPDATED:
      return { ...state, data: { ...state.data, ...action.data } };
    case ActionType.MARKUP_V2_CONFIG_DATA_UPDATED:
      return { ...state, config: { ...state.config, ...action.data } };
    case ActionType.MARKUP_V2_EDITOR_DATA_FETCHED:
      return { ...state, data: { ...action.data } };
    case ActionType.MARKUP_V2_EDITOR_DATA_COPIED:
      return { ...state, data: { ...action.data, id: null } };
    case ActionType.MARKUP_V2_EDITOR_DATA_VALIDATED:
      return { ...state, validation: { ...action.data } };

    default:
      return state;
  }
};

export default updateMarkupsV2EditorData;
